(ns practitest.frontend.kanban.views
  (:require
    [goog.dom.fullscreen :as fullscreen]
    [practitest.frontend.common-old-fe.i18n :as i18n]
    [practitest.frontend.common-old-fe.logging :as log]
    [practitest.frontend.kanban.board :refer [board-ui]]
    [practitest.frontend.kanban.lanes-editor :refer [lanes-editor-ui]]
    ["react-fontawesome" :as fa]
    [re-frame.core :as re-frame]))

(defn actionlog-ui []
  (let [show? (re-frame/subscribe [:kanban/show-action-log?])
        actions (re-frame/subscribe [:kanban/action-log])]
    (fn []
      [:<>
       [:span.user_actionlogs
        {:on-click #(re-frame/dispatch [:kanban/toggle-action-list])}
        (if @show?
          [:i.fa.fa-eye-slash.fa-fw]
          [:i.fa.fa-list-alt.fa-lg])]
       (when @show?
         [:div.actionlog
          (into [:ul.list-unstyled]
                (for [line @actions]
                  [:li line]))])])))

(defn userlist-ui []
  (let [show? (re-frame/subscribe [:kanban/show-user-list?])
        users (re-frame/subscribe [:kanban/current-users])]
    (fn []
      [:<>
       [:span.user_actionlogs
        {:on-click #(re-frame/dispatch [:kanban/toggle-user-list])}
        (if @show?
          [:i.fa.fa-eye-slash.fa-fw]
          [:i.fa.fa-users.fa-lg.fa-fw])]

       (when @show?
         (into [:div.userlist]
               (for [user @users]
                 [:span.label
                  {:class (case (:state user)
                            "active" "label-success"
                            "label-default")
                   :style {:display :inline-block}
                   :title (str (:name user) " (" (:state user) ")")}
                  (:name user)])))])))

(defn project-list-ui []
  (let [projects (re-frame/subscribe [:kanban/projects])
        current-project-id (re-frame/subscribe [:kanban/current-project])]
    (fn []
      [:form.form-horizontal
       [:div.form-group
        [:label.col-sm-3.mt5 (i18n/t :project)]
        [:div.col-sm-9
         [:select.form-control
          {:value     (or @current-project-id "")
           :read-only true}
          [:optgroup
           [:option
            {:disabled true
             :value    -1}
            (i18n/t :all_projects)]]
          (into [:optgroup]
                (for [[id name] @projects]
                  [:option
                   {:disabled (not= id @current-project-id)
                    :value    id}
                   name]))]]]])))

(defn assigned-to-filter-ui []
  (let [filter-container (re-frame/subscribe [:kanban/assigned-to-filter])
        users (re-frame/subscribe [:kanban/project-users])]
    (fn []
      (let [filter (or @filter-container "none")]
        [:form.form-horizontal
         [:div.form-group.side-by-side
          [:label.col-sm-5.mt5.filter-label (i18n/t :assigned_to)]
          [:div.col-sm-7
           [:select.form-control
            {:value     filter
             :on-change #(
                          (re-frame/dispatch [:kanban/set-assigned-to-filter
                                              (-> % .-target .-value)])
                          (.track js/mixpanel "Task Board - Filter by assigned To")
                          )}
            (into [:<>]
                  (cons
                    [:option {:value "none"} (i18n/t :everybody)]
                    (for [[value user _avatar] (sort-by :name @users)] ;old_to_new_frontend replaced last with :name
                      [:option {:value value} user])))]]]]))))

(defn card-types-filter-ui []
  (let [filter-container (re-frame/subscribe [:kanban/card-types-filter])]
    (fn []
      (let [filter (or @filter-container "none")]
        [:form.form-horizontal
         [:div.form-group.side-by-side
          [:label.col-sm-3.mt5.filter-label (i18n/t :type)]
          [:div.col-sm-9
           [:select.form-control
            {:value     filter
             :on-change #(
                          (re-frame/dispatch [:kanban/set-card-types-filter
                                              (-> % .-target .-value)])
                          (.track js/mixpanel "Task Board - Filter By Type"))}
            (into [:<>]
                  (for [[value label] [["none" (i18n/t :all_types)]
                                       ["Issue" (i18n/t :issues)]
                                       ["QtestDesign" (i18n/t :tests)]
                                       ["Requirement" (i18n/t :requirements)]
                                       ["Suite" (i18n/t :sets)]]]
                    [:option {:value value}
                     label]))]]]]))))

(defn fullscreen-btn-ui []
  [:button.btn.btn-default.btn-outline-secondary.btn-width.pull-right
   {:on-click (fn [e]
                (.preventDefault e)
                (if (fullscreen/isFullScreen)
                  (fullscreen/exitFullScreen)
                  (fullscreen/requestFullScreen (js/document.getElementById "kanban-board"))))}
   (if (fullscreen/isFullScreen)
     [:i.fa.fa-compress]
     [:i.fa.fa-expand])])

(defn main-panel []
  (let [can-edit-lanes? (re-frame/subscribe [:kanban/can-edit-lanes?])
        mode (re-frame/subscribe [:kanban/mode])]
    (fn []
      (log/info :main-panel @mode)
      [:div.grid-page
       (case @mode
         :main
         [:div.old-frontend-inner-container
          [:div.row]
          [:div.row]
          [:div.row.pt_tour_taskboard_toprow {:style {:margin-left 0}}
           [:div.col-md-3
            [assigned-to-filter-ui]
            ]
           [:div.col-md-3
            [card-types-filter-ui]
            ]
           [:div.col-md-3]
           [:div.col-md-3.side-by-side
            [:div.col-md-9 (when @can-edit-lanes?
                             [:button.btn.btn-outline-secondary
                              {:on-click #(
                                           (re-frame/dispatch [:kanban/switch-mode :edit-lanes])
                                           (.track js/mixpanel "Task Board - Customize Lanes"))}
                              [:i.fa.fa-cog.fa-fw] (i18n/t :customize_lanes)])]
            [:div.col-md-1
             [actionlog-ui]
             ]
            [:div.col-md-1
             [userlist-ui]
             ]]]

          [:div.row.pt_tour_taskboard_board.pd-top-15
           [:div.col-md-12.col-lg-12
            [board-ui]
            ]]
          [:div.row.display_block
           {:style {:padding-top "4px"}} [fullscreen-btn-ui]]]


         :edit-lanes
         [:<>
          [:div.row
           [:div.col-md-9
            [:legend (i18n/t :task_board_beta)]]
           [:div.col-md-3
            [:a.btn.btn-outline-secondary
             {:href     "#"
              :on-click (fn [e]
                          (.preventDefault e)
                          (re-frame/dispatch [:kanban/switch-mode :main]))}
             (i18n/t :back_to_task_board)]
            [fullscreen-btn-ui]]]
          [:div.row
           [:div.col-md-12 [lanes-editor-ui]]]]
         ;; following is only needed because this component might be rendered before the internal db is initialized
         ;; one way to fix it is to use dispatch-sync for initialization
         ;; another is to show some placeholder
         ;; later is simpler
         [:<>
          [:div.row
           [:div.col-md-12]]])])))
